const imageSliderExpand = ($el) => {
    $($el).click(function (el) {
        $(this).parent().toggleClass('text-imagegallery--modal');
        $('body').toggleClass('noscroll');
        $('html').toggleClass('noscroll');
        $(this).parent().find('.slick-slider')[0].slick.refresh();
        if($(this).parent().find('.slick-slider')[1]) $(this).parent().find('.slick-slider')[1].slick.refresh();
    });
};

export default imageSliderExpand;
